import { Component } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ChangePasswordService} from "../change-password/change-password.service";
import {lastValueFrom} from "rxjs";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-troca-obrigatoria-senha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatIconModule],
  templateUrl: './troca-obrigatoria-senha.component.html',
  styleUrls: ['./troca-obrigatoria-senha.component.css']
})
export class TrocaObrigatoriaSenhaComponent {
  public form: FormGroup = new FormGroup({
    newPassword: new FormControl('', [Validators.required]),
    confirmNewPassword: new FormControl('', [Validators.required]),
  });

  public constructor(
    private changePasswordService: ChangePasswordService,
    private matDialogRef: MatDialogRef<ChangePasswordService>,
  ) {
  }

  protected async save(): Promise<void> {
    try {
      this.changePasswordService.showSpinner();
      await lastValueFrom(this.changePasswordService.setNewPassword(
        this.form.get('newPassword')?.value,
        this.form.get('confirmNewPassword')?.value
      ));
      this.changePasswordService.toasterSuccess('Senha alterada com sucesso!');
      this.matDialogRef.close();
    } catch (e: any) {
      this.changePasswordService.toasterError(e['error']);
    } finally {
      this.changePasswordService.hideSpinner();
    }
  }
}
